import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'sa-ui';
import { injectIntl } from 'react-intl';
import { Alert } from 'react-bootstrap';
import messages from './classesStudentsMessages';

const ClassesStudentsRemoveConfirmationModal = (props) => (
  <Modal
    {...props}
    title={props.intl.formatMessage(messages.removeGroup)}
    message={props.intl.formatMessage(messages.removeGroupConfirmation)}
    icon="ti-trash"
    buttons={[
      {
        onClick: props.onClose,
        label: props.intl.formatMessage(messages.cancel),
      },
      {
        onClick: props.onContinue,
        label: props.intl.formatMessage(messages.continue),
        primary: true,
        disabled: props.error,
      },
    ]}
  >
    {props.error && (
      <Alert variant="danger">
        {props.intl.formatMessage(messages.errorMessageAnswerRegistered)}
      </Alert>
    )}
  </Modal>
);

ClassesStudentsRemoveConfirmationModal.propTypes = {};

export default injectIntl(ClassesStudentsRemoveConfirmationModal);
